/**
 * Formata um número para uma string de moeda padrão brasileira (ex: R$ 1.234,56).
 * @param {number} value - O valor numérico a ser formatado.
 * @returns {string} A string de moeda formatada.
 */
export const formatCurrency = (value) => {
    // Cria um novo objeto Intl.NumberFormat para o português do Brasil,
    // configurado para o estilo de moeda BRL.
    return new Intl.NumberFormat('pt-BR', { 
        style: 'currency', 
        currency: 'BRL' 
    }).format(value || 0); // Formata o valor, usando 0 como padrão se o valor for nulo ou indefinido.
};

/**
 * Formata um número para uma string de moeda compacta para valores grandes (ex: R$ 1,2M ou R$ 500k).
 * @param {number} value - O valor numérico a ser formatado.
 * @returns {string} A string de moeda compacta formatada.
 */
export const formatCompactCurrency = (value) => {
    // Se o valor for 1 milhão ou mais, formata como "M" (milhões).
    if (value >= 1000000) {
        // Divide por 1 milhão, fixa em uma casa decimal e substitui o ponto por vírgula.
        return `R$ ${(value / 1000000).toFixed(1).replace('.', ',')}M`;
    }
    // Se o valor for 1 mil ou mais, formata como "k" (milhares).
    if (value >= 1000) {
        // Divide por 1 mil e formata como um inteiro.
        return `R$ ${(value / 1000).toFixed(0)}k`;
    }
    // Para valores menores que 1000, retorna o formato de moeda padrão.
    return `R$ ${value}`;
};

/**
 * Formata o nome completo de um usuário para exibir o primeiro e o último nome.
 * @param {string} fullName - O nome completo do usuário.
 * @returns {string} O nome formatado (ex: "John Doe").
 */
export const formatUserName = (fullName) => {
    if (!fullName || typeof fullName !== 'string') {
        return 'Nome não disponível';
    }
    const names = fullName.trim().split(' ');
    if (names.length === 1) {
        return names[0];
    }
    return `${names[0]} ${names[names.length - 1]}`;
};
